<template>
  <div>
    <v-container my-3 px-0 pb-0 fluid white>
      <v-layout row wrap text-xs-center justify-center>
        <v-flex xs12>
          <svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="4.5" y="4" width="24" height="24" rx="5" fill="#FBC109" />
          </svg>
        </v-flex>
        <v-flex xs12 my-3>
          <h1 class="navy--text desktop-h1">Tasks</h1>
        </v-flex>
        <v-flex xs12 sm8 my-3 gray--text body-5 op-1>
          Tasks are high-quality, ready, and easy-to-use content which help develop all students' mathematical skills. They are perfect for every learning environment - start using them today! For spanish tasks click <a style="color: #3296f3" href="https://media.brainingcamp.com/static/tasks/pdfs/spanish_guide.pdf" target="_blank">here</a>.
        </v-flex>
      </v-layout>
    </v-container>
    <v-container fluid ice lighten-1>
      <v-container class="task_grid">
        <div class="task_filters">
          <v-layout wrap>
            <v-flex xs12>
              <v-text-field
                solo
                prepend-inner-icon="search"
                v-model="searchAC"
                clearable
                label="Search..."
              >
              </v-text-field>
            </v-flex>
            <v-flex xs12 class="filter_container" style="margin-top: -12px">
              <p class="mb-2" style="color: #673AB7; font-size: 16px; font-weight: 600;">Grade</p>
              <v-divider />                  
              <v-layout mt-2 justify-center align-center row wrap>
                <v-flex ma-1 v-for="item in grades" :key="item.grade"> 
                  <div class="grade_btn" :class="{active: item.selected}" @click="gradeChipDidClick(item)">{{ item.grade === 0 ? 'K' : item.grade }}</div>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12 my-3 class="filter_container">
              <p class="mb-2" style="color: #673AB7; font-size: 16px; font-weight: 600;">Domains</p>
              <v-divider />
              <v-checkbox
                v-for="(domain, idx) in domains"
                :key="idx"
                hide-details
                height="44"
                :label="domain"
                @change="checkboxDidChange(domain)"
                :value="selectedDomains.indexOf(domain) !== -1"
              >
              </v-checkbox>
            </v-flex>
          </v-layout>
        </div>
        <div class="task_results">
          <v-layout wrap justify-left align-top>
            <template
              v-for="task in filteredTasks.slice((pageNum - 1) * pageSize, (pageNum - 1) * pageSize + pageSize)"
            >
              <div class="task_item"
                :key="task.data.id"
              >
                <a :href="'https://media.brainingcamp.com/static/tasks/pdfs/' + task.data.pdfURI + '.pdf'" target="_blank">
                  <div class="task">
                    <div class="task_header">
                      <div class="title_container">
                        <p class="task_title">{{ task.data.title }}</p>
                      </div>
                      <img :src="'https://media.brainingcamp.com/static/tasks/thumbs/' + task.data.thumb" style="width: 100%;">
                    </div>
                    <p class="task_desc">
                      {{ task.data.description }}
                    </p>
                    <div class="task_standards">
                      <v-chip
                        color="ice lighten-1"
                        v-for="(standard, idx) in task.data.standards"
                        :key="idx"
                        class="task_standard"
                      >
                        {{ standard }}
                      </v-chip>
                    </div>
                  </div>
                </a>
              </div>
            </template>
          </v-layout>
          <div class="pagination">
            <template v-for="n in Math.ceil(filteredTasks.length / pageSize)">
              <div class="page_num" :key="n" @click="pageDidClick(n)">
              <span :class="{active:isActivePage(n)}">{{n}}</span>
              </div>
            </template>
          </div>
        </div>
      </v-container>
    </v-container>
  </div>
</template>

<script>
import _ from 'lodash'
import tasks from '@/data/tasks/'

export default {
  data: function () {
    return {
      grades: null,
      selectedDomains: [],
      searchTerm: null,
      searchAC: null,
      pageNum: 1,
      pageSize: 18
    }
  },
  components: {
  },
  computed: {
    filteredTasks: function () {
      let allTasks = this.getTasksByGrade();

      if (this.selectedDomains.length > 0) {
        const domains = this.selectedDomains;
        let domainFilteredTasks = _.filter(allTasks, (task) => {
          return domains.indexOf(task.data.domain) !== -1;
        })

        allTasks = domainFilteredTasks;
      }

      // apply search terms to filtered items
      if (this.searchTerm) {
        return _.filter(allTasks, (task) => {
          const keywords = task.data.keywords.split(",");
          for (let i = 0; i < keywords.length; i++) {
            const keyword = keywords[i]

            if (_.startsWith(keyword, this.searchTerm)) return true
          }

          return false
        })
      }
    

      return allTasks;
    },
    domains: function () {
      let allTasks = this.getTasksByGrade();
      const results = [];
      allTasks.forEach(task => {
        const d = task.data;
        const domain = d.domain;

        if (results.indexOf(domain) === -1) {
          results.push(domain)
        }
      });

      return results;
    }
  },
  watch: {
    searchAC: function (val) {
      this.searchTerm = val
    }
  },
  mounted: function () {
    const grades = [];
    tasks.forEach(task => {
      let g = task.grade;
      if (grades.indexOf(g) < 0) {
        grades.push(g);
      }
    });

    this.grades = grades.map(v => {
      return {
        grade: v,
        selected: false
      }
    });
  },
  methods: {
    getTasksByGrade: function () {
      let allTasks = [...tasks];
      const gradesToFilterBy = _.filter(this.grades, (grade) => {
        return grade.selected;
      })
      if (gradesToFilterBy.length > 0) {
        const g = gradesToFilterBy.map(item => {
          return item.grade
        })
        let gradeFilteredTasks = _.filter(allTasks, (task) => {
          return g.indexOf(task.grade) !== -1;
        })

        allTasks = gradeFilteredTasks;
      }

      return allTasks;
    },
    gradeChipDidClick: function (gradeClicked) {
      this.selectedDomains = [];
      this.pageNum = 1;
      gradeClicked.selected = !gradeClicked.selected;
    },
    checkboxDidChange: function (domain) {
      this.pageNum = 1;
      const idx = this.selectedDomains.indexOf(domain);
      if (idx === -1) {
        this.selectedDomains.push(domain);
      } else {
        this.selectedDomains.splice(idx, 1);
      }
    },
    isActivePage: function(page) {
      return page === this.pageNum;
    },
    pageDidClick: function(page) {
      this.pageNum = page;
    }
  }
}
</script>

<style scoped>
.grade_btn {
  user-select: none;
  font-size: 16px;
  font-weight: 500;
  padding: 8px;
  width: 42px;
  height: 42px;
  background: #EBF5FE;
  border-radius: 100px;
  color: black;
  cursor: pointer;
  text-align: center;
}

.active {
  background-color: #3296f3;
  color: white;
}

.filter_container {
  border: 4px solid #D7EBFF !important;
  border-radius: 18px !important;
  padding: 24px;
  background-color: white;
}


.task_grid {
  display: grid;
  grid-template-columns: 240px auto;
  grid-template-areas: "filters  results";
}

.task_filters {
  grid-area: filters;
}

.task_results {
  grid-area: results;
  margin-left: 24px;
}

.task_item {
  display: flex;
  margin: 0px 8px 12px 8px;
}

.task {
  width: 270px;
  height: 420px;
  border-radius: 18px;
  background-color: white;
}

.task_header {
  padding: 0 24px;
  border-radius: 18px 18px 0 0;
  background-color: #3296f3;
  height: 160px;
}

.task img {
  height: 148px;
  border-radius: 12px;
}

.task .title_container {
  height: 64px;
  display: flex;
  align-items: center;
}

.task_title {
  margin: auto;
  font-size: 18px;
  color: white;
  font-weight: 600;
  text-align: center;
}

.task_desc {
  font-size: 14px;
  font-weight: 300;
  margin-top: 80px;
  height: 120px;
  padding: 0 24px;
  color: #2B2E31;
}

.task_standards {
  padding: 0 24px;
  margin: 24px 0 0 0;
}

.task_standard {
  font-size: 10px;
  height: 20px;
  text-transform: capitalize;
}

.pagination {
  padding: 8px 16px;
  text-align: center;
}

.page_num {
  display: inline-block;
  margin: 0 8px;
  font-size: 16px;
  font-weight: 300;
  cursor: pointer;
}

.page_num .active {
  font-weight: 500;
  background-color: transparent;
  color: #0089a6;
  text-decoration: underline;
}

</style>
